import React from 'react';
import UserManagement from './UserManagement';
import TreatmentTypeManagement from './TreatmentTypeManagement';
import DoctorManagement from './DoctorManagement';
import CategorieIntrantManagement from './CategorieIntrantManagement';
import FournisseurManagement from './FournisseurManagement';
import AssureurManagement from './AssureurManagement';
import MedicamentManagement from './MedicamentManagement';
import PrestataireManagement from './PrestataireManagement';
import TypeProtheseManagement from './TypeProtheseManagement';

interface AdminDashboardProps {
  activeTab: 'users' | 'treatments' | 'doctors' | 'categories' | 'fournisseurs' | 'assureurs' | 'medicaments' | 'prestataires' | 'types-protheses';
}

const AdminDashboard: React.FC<AdminDashboardProps> = ({ activeTab }) => {
  return (
    <div>
      <UserManagement isVisible={activeTab === 'users'} />
      <TreatmentTypeManagement isVisible={activeTab === 'treatments'} />
      <DoctorManagement isVisible={activeTab === 'doctors'} />
      <CategorieIntrantManagement isVisible={activeTab === 'categories'} />
      <FournisseurManagement isVisible={activeTab === 'fournisseurs'} />
      <AssureurManagement isVisible={activeTab === 'assureurs'} />
      <MedicamentManagement isVisible={activeTab === 'medicaments'} />
      <PrestataireManagement isVisible={activeTab === 'prestataires'} />
      <TypeProtheseManagement isVisible={activeTab === 'types-protheses'} />
    </div>
  );
};

export default AdminDashboard;